// 3rd-party modules
import { message } from "antd";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import camelcaseKeys from 'camelcase-keys';


import { AutoComplete, Select as AntSelect, SelectProps as AntSelectProps } from 'antd';


// project modules
import { apiCall } from "../../../../../helpers/apiHelper";
import Button from "../../../../shared/button";
import Checkbox from "../../../../shared/inputs/checkbox";
import { convertToSnakecase } from "../../../../../helpers/objectHelper";
import Loader from "../../../../shared/loader";
import Input, { Password } from "../../../../shared/inputs/input";
import yup from "../../../../../plugins/yup";
import Options from "../../../../shared/options";
import Select from "../../../../shared/inputs/select";

import Schedules  from "../../../../shared/schedule/Schedules";
import ScheduleModal  from "../../../../shared/schedule/ScheduleModal";
import { ScheduleModel } from "../../../../shared/schedule/Schedules";

//import  ScheduleModel  from "../../../../../models/types/ScheduleModel";



// apis
import * as DashApi from '../../../../../apis/dashApi';

// models
import { Account } from "../../../../../models/account";
import { AccountKiboshDevice } from "../../../../../models/accountKiboshDevice";
import { kiboshDeviceWifiConfigUpdateViewModel } from "../../../../../models/types/kiboshDeviceWifiConfig";
import { KiboshDeviceWifiConfig } from "../../../../../models/kiboshDeviceWifiConfig";
import { ApiResponse } from "../../../../../models/response";

type Props = {
  account?: Account;
  accountKiboshDevice: AccountKiboshDevice;
  refresh?: boolean;
  onCancel?: () => void;
  onSave?: (account: Account) => void;
};

export default function KiboshDeviceWifiSettings({ account, refresh, accountKiboshDevice, onCancel, onSave }: Props) {
  const [loading, setLoading] = useState(false);
  const abortController = new AbortController();

  const schema = yup.object().shape({
    radio24GhzEnabled: yup.string().label("2.4GHz"),
    radio24GhzName: yup.string().label("2.4GHz Name").max(256),
    radio24GhzKey: yup.string().label("2.4GHz Key").max(256).min(8),
    radio5GhzEnabled: yup.string().label("5GHz"),
    radio5GhzName: yup.string().label("5GHz Name").max(256),
    radio5GhzKey: yup.string().label("5GHz Key").max(256).min(8),
    radioGuest24GhzEnabled: yup.string().label("2.4GHz Guest Wifi"),
    radioGuest24GhzName: yup.string().label("2.4GHz Guest Wifi Name").max(256),
    radioGuest24GhzKey: yup.string().label("2.4GHz Guest Wifi Key").max(256).min(8),
    radioGuest5GhzEnabled: yup.string().label("5GHz Guest Wifi"),
    radioGuest5GhzName: yup.string().label("5GHz Guest Wifi Name").max(256),
    radioGuest5GhzKey: yup.string().label("5GHz Guest Wifi Key").max(256).min(8)
  });
  const { control, handleSubmit, reset } = useForm<kiboshDeviceWifiConfigUpdateViewModel | any>({
    defaultValues: {
      radio24GhzEnabled: false,
      radio24GhzName: "",
      radio24GhzKey: "",
      radio5GhzEnabled: false,
      radio5GhzName: "",
      radio5GhzKey: "",
      radioGuest24GhzEnabled: false,
      radioGuest24GhzName: "",
      radioGuest24GhzKey: "",
      radioGuest5GhzEnabled: false,
      radioGuest5GhzName: "",
      radioGuest5GhzKey: ""
    },
    resolver: yupResolver(schema),
  });



  const testSchedule:ScheduleModel = {
  id: "test",
  fromAmPm: "am",
  fromDay: undefined,
  fromHour: "1",
  fromMinute: "15",
  toAmPm: "am",
  toDay: undefined,
  toHour: "4",
  toMinute: "30",
  activeDays: "mon,tue",
  enabled: "1",
  repeats: "daily"
  };

  const newScheduleLabel = "Update Schedule"
  const scheduleHoursLabel = "Disabled Hours"

  const [radio24GhzEnabled,      setRadio24GhzEnabled]      = useState<string>("disabled");
  const [radio5GhzEnabled,       setRadio5GhzEnabled]       = useState<string>("disabled");
  const [radioGuest24GhzEnabled, setRadioGuest24GhzEnabled] = useState<string>("disabled");
  const [radioGuest5GhzEnabled,  setRadioGuest5GhzEnabled]  = useState<string>("disabled");



  const [radio24GhzSchedules,      setRadio24GhzSchedules]      = useState<any[]>([]);
  const [radio5GhzSchedules,       setRadio5GhzSchedules]       = useState<any[]>([]);
  const [radioGuest24GhzSchedules, setRadioGuest24GhzSchedules] = useState<any[]>([]);
  const [radioGuest5GhzSchedules,  setRadioGuest5GhzSchedules]  = useState<any[]>([]);

  const [initialized, setInitialized] = useState<boolean>(false);



  useEffect(() => {
    getKiboshDeviceWifiConfigAsync();

  }, []);

  const getKiboshDeviceWifiConfigAsync = async () => {

    let data:any = await getKiboshDeviceWifiConfig() || {};
    let enabledKeys  = [ "radio24GhzEnabled", "radio5GhzEnabled", "radioGuest24GhzEnabled", "radioGuest5GhzEnabled"]
    let scheduleKeys = [ "radio24GhzSchedules", "radio5GhzSchedules", "radioGuest24GhzSchedules", "radioGuest5GhzSchedules" ]
    let enabledSetters = [ setRadio24GhzEnabled, setRadio5GhzEnabled, setRadioGuest24GhzEnabled, setRadioGuest5GhzEnabled ]

    for(let ki=0; ki < enabledKeys.length; ki++) {
      let ek = enabledKeys[ki]
      let sk = scheduleKeys[ki]
      let enabledString = data[ek] ? "enabled" : "disabled"
      if(data[sk] && (data[sk]).length > 0) {
        enabledString = "scheduled"
      }
      enabledSetters[ki](enabledString)
    }

    //if(data["radio24GhzSchedules"] && data["radio24GhzSchedules"].length == 0) {
    //  data["radio24GhzSchedules"] = [ testSchedule ]
    //}


    setRadio24GhzSchedules(data["radio24GhzSchedules"])
    setRadio5GhzSchedules(data["radio5GhzSchedules"])
    setRadioGuest24GhzSchedules(data["radioGuest24GhzSchedules"])
    setRadioGuest5GhzSchedules(data["radioGuest5GhzSchedules"])


    setInitialized(true)
    


    reset(data);
  }

  const getKiboshDeviceWifiConfig = async () => {
    setLoading(true);
    const response = await apiCall(DashApi.getKiboshDeviceWifiConfig(accountKiboshDevice?.kiboshDeviceReference!, abortController.signal));
    setLoading(false);

    return response.success && response.data?.value ? camelcaseKeys(response.data?.value, { deep: true })  : null;
  };


  const convertArrayToSnakeCase = (a:any[])  => {
    for(let i=0; i< a.length; i++) {
      a[i] = convertToSnakecase(a[i], [], [] )
    }
    return a;
  }

  const onSubmit: SubmitHandler<kiboshDeviceWifiConfigUpdateViewModel> = async (formData: kiboshDeviceWifiConfigUpdateViewModel) => {
    setLoading(true);






    formData["radio24GhzSchedules"]      = radio24GhzEnabled == "scheduled"      ? convertArrayToSnakeCase( radio24GhzSchedules )      : []
    formData["radio5GhzSchedules"]       = radio5GhzEnabled  == "scheduled"      ? convertArrayToSnakeCase( radio5GhzSchedules )       : []
    formData["radioGuest24GhzSchedules"] = radioGuest24GhzEnabled == "scheduled" ? convertArrayToSnakeCase( radioGuest24GhzSchedules ) : []
    formData["radioGuest5GhzSchedules"]  = radioGuest5GhzEnabled != "scheduled"  ? convertArrayToSnakeCase( radioGuest5GhzSchedules )  : []

    formData["radio24GhzEnabled"]      = radio24GhzEnabled != "disabled" ? true : false
    formData["radio5GhzEnabled"]       = radio5GhzEnabled != "disabled" ? true : false
    formData["radioGuest24GhzEnabled"] = radioGuest24GhzEnabled != "disabled" ? true : false
    formData["radioGuest5GhzEnabled"]  = radioGuest5GhzEnabled != "disabled" ? true : false




    formData.kiboshDeviceReference = accountKiboshDevice.kiboshDeviceReference!;
    let data = convertToSnakecase(formData, [], ["kiboshDeviceReference"]);
    

    let matchKeys   = [ "radio5_", "radio24_",  "guest5_", "guest24_" ]
    let replaceKeys = [ "radio_5", "radio_2_4", "guest_5", "guest_2_4" ]
    for( let prop of Object.keys(data)) {
      for(let ki=0; ki < matchKeys.length; ki++) {
        let m = matchKeys[ki]
        let r = replaceKeys[ki]
        if(prop.includes(m)) {
          const newKey = prop.replace(m, r);
          if (newKey !== prop) {
            data[newKey as keyof object] = data[prop as keyof object];
            delete data[prop as keyof object];
          }

        }
      }
    }


    const response: ApiResponse = await apiCall(DashApi.updateKiboshDeviceWifiConfig(data, abortController.signal));



    if (response.success) {
      message.success(`Wifi setting updated successfully.`);

      getKiboshDeviceWifiConfigAsync();

      if (onSave) onSave(response.data?.value);

    } else
      message.error(response.error?.value);

    setLoading(false);
  };


    const enabledLabelRender = (opt:any) => {
      let valToColor:any = { "enabled" : "green", "disabled" : "red", "scheduled" : "#e89468" };
      let color:any = valToColor[ opt.value]
      if(opt.label && color) {
        return <span data-weight="900"  style={{ "color":color }}>{opt.label}</span>
      } else if(color) {
        return <span  data-weight="900" style={{ "color":color }}>{opt.value}</span>
      } else {
        return <span>{opt.value}</span>
      }
  };

  return (
    <>
      { (loading || !initialized ) &&
        <Loader />
      }
      <view>
        <view data-scroll="">
          <group data-gap="20" data-space='15'>
            <group data-gap="10" data-direction="column" data-length="autofit" data-min-length='400' data-max-length='500' style={{ alignItems: "flex-start" }} >
                  <label data-weight="900" >
                    <text>2.4GHz WiFi: </text>
                    <AntSelect
                      style = {{"width":"200px", "maxWidth":"200px", "marginLeft":"10px" }}
                      labelRender = { enabledLabelRender }
                      options={ 
                        [ {value:"disabled", label:"Disabled"}, {value:"enabled", label:"Enabled"}, {value:"scheduled", label:"Scheduled"} ]
                      }
                      value={radio24GhzEnabled}
                      onChange={setRadio24GhzEnabled}
                    />
                  </label>

              <Input
                control={control}
                name="radio24GhzName"
                label="2.4Ghz WiFi Name"
                size="large"
              />
              <Password
                control={control}
                name="radio24GhzKey"
                label="2.4Ghz WiFi Passsword"
                size="large"
              />
              { initialized && radio24GhzEnabled == "scheduled" &&
                <Schedules
                  schedules={radio24GhzSchedules}
                  onChange={ (schedules:ScheduleModel[]) => { setRadio24GhzSchedules(schedules); } }
                  hoursLabel={ scheduleHoursLabel }
                  newLabel={ newScheduleLabel }
                />
              }
              { (!(initialized && radio24GhzEnabled == "scheduled")) &&
                <div></div>
              }

            </group>
            <group data-gap="10" data-direction="column" data-length="autofit" data-min-length='400' data-max-length='500' style={{ alignItems: "flex-start" }} >
                  <label data-weight="900" >
                    <text>5GHz WiFi: </text>
                    <AntSelect
                      style = {{"width":"200px", "maxWidth":"200px", "marginLeft":"10px" }}
                      labelRender = { enabledLabelRender }
                      options={ 
                        [ {value:"disabled", label:"Disabled"}, {value:"enabled", label:"Enabled"}, {value:"scheduled", label:"Scheduled"} ]
                      }
                      value={radio5GhzEnabled}
                      onChange={setRadio5GhzEnabled}

                    />
                  </label>
        
              <Input
                control={control}
                name="radio5GhzName"
                label="5Ghz WiFi Name"
                size="large"
              />
              <Password
                control={control}
                name="radio5GhzKey"
                label="5Ghz WiFi Passsword"
                size="large"
              />
              { initialized && radio5GhzEnabled == "scheduled" &&
                <Schedules
                  schedules={radio5GhzSchedules}
                  onChange={ (schedules:ScheduleModel[]) => { setRadio5GhzSchedules(schedules); } }
                  hoursLabel={ scheduleHoursLabel }
                  newLabel={ newScheduleLabel }
                />
              }
              { (!(initialized && radio5GhzEnabled == "scheduled")) &&
                <div></div>
              }


            </group>
          </group>
          <group data-space-top="10" data-space-horizontal="15">
            <text data-weight="700" data-text-size="medium">Guest WIFI</text>
          </group>
          <group data-gap="20" data-space='15'>
            <group data-gap="10" data-direction="column" data-length="autofit" data-min-length='400' data-max-length='500' style={{ alignItems: "flex-start" }} >
                  <label data-weight="900" >
                    <text>2.4GHz Guest WiFi: </text>
                    <AntSelect
                      style = {{"width":"200px", "maxWidth":"200px", "marginLeft":"10px" }}
                      labelRender = { enabledLabelRender }
                      options={ 
                        [ {value:"disabled", label:"Disabled"}, {value:"enabled", label:"Enabled"}, {value:"scheduled", label:"Scheduled"} ]
                      }
                      value={radioGuest24GhzEnabled}
                      onChange={setRadioGuest24GhzEnabled}
                    />
                  </label>
              
              <Input
                control={control}
                name="radioGuest24GhzName"
                label="2.4Ghz Guest WiFi Name"
                size="large"
              />
              <Password
                control={control}
                name="radioGuest24GhzKey"
                label="2.4Ghz Guest WiFi Passsword"
                size="large"
              />
              { initialized && radioGuest24GhzEnabled == "scheduled" &&

                <Schedules
                  schedules={radioGuest24GhzSchedules}
                  onChange={ (schedules:ScheduleModel[]) => { setRadioGuest24GhzSchedules(schedules); } }
                  hoursLabel={ scheduleHoursLabel }
                  newLabel={ newScheduleLabel }
                />
              }
              { (!(initialized && radioGuest24GhzEnabled == "scheduled")) &&
                <div></div>
              }

            </group>
            <group data-gap="10" data-direction="column" data-length="autofit" data-min-length='400' data-max-length='500' style={{ alignItems: "flex-start" }} >
                  <label data-weight="900" >
                    <text>5GHz Guest WiFi: </text>
                    <AntSelect
                      style = {{"width":"200px", "maxWidth":"200px", "marginLeft":"10px" }}
                      labelRender = { enabledLabelRender }
                      options={ 
                        [ {value:"disabled", label:"Disabled"}, {value:"enabled", label:"Enabled"}, {value:"scheduled", label:"Scheduled"} ]
                      }
                      value={radioGuest5GhzEnabled}
                      onChange={setRadioGuest5GhzEnabled}

                    />
                  </label>

              <Input
                control={control}
                name="radioGuest5GhzName"
                label="5Ghz Guest WiFi Name"
                size="large"
              />
              <Password
                control={control}
                name="radioGuest5GhzKey"
                label="5Ghz Guest WiFi Passsword"
                size="large"
              />
              { initialized && radioGuest5GhzEnabled == "scheduled" &&

                <Schedules
                  schedules={radioGuest5GhzSchedules}
                  onChange={ (schedules:ScheduleModel[]) => { setRadioGuest5GhzSchedules(schedules); } }
                  hoursLabel={ scheduleHoursLabel }
                  newLabel={ newScheduleLabel }
                />
              }
              { (!(initialized && radioGuest5GhzEnabled == "scheduled")) &&
                <div></div>
              }

            </group>
          </group>
        </view>
        <group data-space="10" data-gap="10">
          <Button data-length="forcefit" primary onClick={handleSubmit(onSubmit)}>
            <text>Save Changes</text>
          </Button>
        </group>
      </view>
    </>
  );
}
